import { rankingItems } from '@/mocks/gossip';

export default function RankingSection() {
  const topThree = rankingItems.slice(0, 3);
  const rest = rankingItems.slice(3);

  return (
    <section id="ranking" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-8 md:mb-10">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-accent-400 mb-3">
            <i className="ri-bar-chart-grouped-line" aria-hidden="true"></i>
            HOT · 今日吃瓜热度榜
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-background-50 leading-tight mb-3">
            今日吃瓜热度榜 · 讨论最集中的十件事
          </h2>
          <p className="text-sm md:text-base text-background-100/70 leading-relaxed font-body">
            榜单根据页面内公开讨论热度综合排序，仅反映话题受关注程度，不代表事件真实性，也不构成任何结论。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-4 md:mb-5">
          {topThree.map((item, index) => (
            <article key={item.id} className="rounded-lg bg-white/5 border border-white/10 p-5">
              <div className="flex items-center justify-between mb-3">
                <span
                  className={`w-9 h-9 flex items-center justify-center rounded-md font-heading text-lg ${
                    index === 0 ? 'bg-primary-500 text-background-50' : 'bg-accent-500 text-foreground-950'
                  }`}
                >
                  {item.id}
                </span>
                <span className="inline-flex items-center gap-1 text-xs text-background-100/80 font-label">
                  <i className="ri-fire-line text-accent-400" aria-hidden="true"></i>
                  {item.heat}
                </span>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-background-50 leading-snug mb-2">{item.title}</h3>
              <span className="inline-block px-2 py-0.5 rounded-md bg-white/10 text-background-100/80 text-[11px] font-label">
                {item.category}
              </span>
            </article>
          ))}
        </div>

        <ol className="rounded-lg bg-white/5 border border-white/10 divide-y divide-white/10">
          {rest.map((item) => (
            <li key={item.id} className="flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3.5">
              <span className="w-6 shrink-0 font-heading text-base text-foreground-500">{item.id}</span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-background-50 truncate font-body">{item.title}</p>
                <div className="mt-1.5 h-1.5 rounded-full bg-white/10 overflow-hidden">
                  <span
                    className="block h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                    style={{ width: `${item.value}%` }}
                  ></span>
                </div>
              </div>
              <span className="shrink-0 text-[11px] md:text-xs text-background-100/70 font-label">{item.heat}</span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}